import 'knockout.validation';
import ko from 'knockout';
import { R } from './Resources.resx';

export class EmailViewModel {
	public value = ko.observable<string>();
	// True if the user has focus in the field
	public isSelected = ko.observable(false);
	// True if the field has been left with content at least once. Validation should only occur if it is validating.
	public isValidating = ko.observable(false);
	public isValid = ko.pureComputed(() => {
		const emailValidator = ko.validation.rules['email'].validator;
		return this.value() && emailValidator(this.value(), true);
	});

	constructor() {
		this.value.extend({
			email: {
				onlyIf: () => this.isValidating(),
				message: R.ErrorInvalidEmail,
			},
		});
		this.isSelected.subscribe((newValue) => {
			if (!newValue && this.value()?.trim()) {
				this.isValidating(true);
			}
		});
	}
}
